import React from 'react';
import PropTypes from 'prop-types';

import NavItem from './NavItem';

const NavItems = ({ routes, modifier, onClick }) => {

  const modifierClass = modifier ? `e84-${ modifier }-nav-items` : '';

  const navItems = routes.map(( route, index ) => {

    return (
      <NavItem key={ `NavItem-${ index }-${ route.to }` }
        id={ route.id }
        dest={ route.to }
        modifier={ modifier }
        onClick={ onClick }
        divided={ !!route.divided }
      >
        { route.label }
      </NavItem>
    );

  });

  return <ul className={ `e84-nav-items ${ modifierClass }` }>{ navItems }</ul>;

};

NavItems.propTypes = {
  routes: PropTypes.array,
  modifier: PropTypes.string,
  onClick: PropTypes.func,
};

export default NavItems;
